import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_2 = { style: {"height":"75vh","overflow":"auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_ExportThemeMenu = _resolveComponent("ExportThemeMenu")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          size: "64"
        })
      ]))
    : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "default_card large mx-0 my-2 pa-2 sticky-card",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              (!_ctx.previewMode)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "d-flex justify-start align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_back, {
                            class: "ml-1 mr-5",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "d-flex align-end justify-end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.themeDB.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.themeDB.name) = $event)),
                            label: "Nom du thème",
                            "hide-details": "",
                            disabled: _ctx.readonly,
                            density: "compact"
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode(_component_v_btn, {
                            elevation: "0",
                            class: "ml-1",
                            disabled: !_ctx.themeDB.name || _ctx.readonly || !!!_ctx.scopeId,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.upsertTheme()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.id ? "Modifier" : "Créer"), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_row, {
              class: "mt-1 ml-1",
              style: {"width":"99.5%","padding-bottom":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pb-0",
                  cols: _ctx.previewMode ? '12' : '6',
                  style: {"max-height":"calc(100vh - 180px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs, {
                      modelValue: _ctx.activeTab,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event)),
                      "fixed-tabs": "",
                      style: {"background-color":"transparent !important","border-radius":"12px"},
                      class: "mb-1"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.showFirstPageSettings)
                          ? (_openBlock(), _createBlock(_component_v_tab, {
                              key: 0,
                              ripple: "",
                              value: "showFirstPageSettings",
                              href: "#showFirstPageSettings"
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("Première page")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showNextSettings)
                          ? (_openBlock(), _createBlock(_component_v_tab, {
                              key: 1,
                              ripple: "",
                              value: "showNextSettings",
                              href: "#showNextSettings"
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("Pages Suivantes")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_tabs_window, {
                      modelValue: _ctx.activeTab,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeTab) = $event)),
                      class: "pt-2",
                      style: {"border":"1px solid #f4f4f4","background-color":"#ffffff"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, {
                          value: "showFirstPageSettings",
                          class: "fill-height ml-2 mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-content-space-between flex-wrap fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"140px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        (
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: 
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '7'
                                                    : '4'
                                            
                                            }, null, 8, ["cols"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                        }, {
                                          default: _withCtx(() => [
                                            (
                                                    _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                    _ctx.themeSettings.firstPage.accountingFirm.position.startsWith(
                                                        'top-',
                                                    )
                                                )
                                              ? (_openBlock(), _createBlock(_component_v_img, {
                                                  key: 0,
                                                  class: "v-responsive",
                                                  src: _ctx.logo,
                                                  style: {"width":"100%","max-width":"80px","height":"auto"}
                                                }, null, 8, ["src"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_v_col, {
                                          cols: 
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '3'
                                                    : '6'
                                            ,
                                          class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              style: _normalizeStyle(_ctx.accountingFirmStyle())
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.accountingFirm.position.startsWith(
                                                            "top-",
                                                        )
                                                            ? _ctx.accountingFirmFirstPage
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["class"])
                                              ]),
                                              _: 1
                                            }, 8, ["style"])
                                          ]),
                                          _: 1
                                        }, 8, ["cols", "class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"512px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "3" }),
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              style: _normalizeStyle(_ctx.clientStyle())
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center",
                                                  style: {"font-size":"24px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.miscellaneous.title
                                                            ? _ctx.bookletTemplateTest.miscellaneous
                                                                  .title
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString((_ctx.themeSettings.firstPage.client.legalForm
                                                            ? _ctx.bookletTemplateTest.client.legalForm +
                                                              " "
                                                            : "") +
                                                        (_ctx.themeSettings.firstPage.client.name
                                                            ? _ctx.bookletTemplateTest.client.name
                                                            : "")), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.client.address
                                                            ? _ctx.bookletTemplateTest.client.address
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.client.siret
                                                            ? _ctx.bookletTemplateTest.client.siret
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.client.ape
                                                            ? _ctx.bookletTemplateTest.client.ape
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["style"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "3" })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"50px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        (
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: 
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '7'
                                                    : '4'
                                            
                                            }, null, 8, ["cols"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                        }, {
                                          default: _withCtx(() => [
                                            (
                                                    _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                    _ctx.themeSettings.firstPage.accountingFirm.position.startsWith(
                                                        'bottom-',
                                                    )
                                                )
                                              ? (_openBlock(), _createBlock(_component_v_img, {
                                                  key: 0,
                                                  class: "v-responsive",
                                                  src: _ctx.logo,
                                                  style: {"width":"100%","max-width":"80px","height":"auto"}
                                                }, null, 8, ["src"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_v_col, {
                                          cols: 
                                                _ctx.themeSettings.firstPage.accountingFirm.logo &&
                                                _ctx.themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '3'
                                                    : '6'
                                            ,
                                          class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              style: _normalizeStyle(_ctx.accountingFirmStyle())
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: _normalizeClass(_ctx.classFirstPageAccountingFirm())
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.themeSettings.firstPage.accountingFirm.position.startsWith(
                                                            "bottom-",
                                                        )
                                                            ? _ctx.accountingFirmFirstPage
                                                            : ""), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["class"])
                                              ]),
                                              _: 1
                                            }, 8, ["style"])
                                          ]),
                                          _: 1
                                        }, 8, ["cols", "class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, {
                          value: "showNextSettings",
                          class: "fill-height mx-5",
                          style: {"max-height":"calc(100vh-240px)","overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-content-space-between flex-wrap fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"140px"},
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: _normalizeClass(_ctx.classNextPages())
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "6" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.toDisplayLogo('top-left'))
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "4",
                                                              class: "d-flex justify-start align-left"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_img, {
                                                                  class: "v-responsive",
                                                                  src: _ctx.logo,
                                                                  style: {"width":"100%","max-width":"80px","height":"auto"}
                                                                }, null, 8, ["src"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 1,
                                                              cols: "4",
                                                              class: "d-flex justify-start align-left"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.displayInformations("top-left")), 1)
                                                              ]),
                                                              _: 1
                                                            })),
                                                        _createVNode(_component_v_col, { cols: "4" }),
                                                        _createVNode(_component_v_col, { cols: "4" })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "6" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "4" }),
                                                        _createVNode(_component_v_col, { cols: "4" }),
                                                        (_ctx.toDisplayLogo('top-right'))
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "4",
                                                              class: "d-flex justify-end align-right"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_img, {
                                                                  class: "v-responsive",
                                                                  src: _ctx.logo,
                                                                  style: {"width":"100%","max-width":"80px","height":"auto"}
                                                                }, null, 8, ["src"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 1,
                                                              cols: "4",
                                                              class: "d-flex justify-end align-right"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.displayInformations("top-right")), 1)
                                                              ]),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["class"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"512px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h1", null, _toDisplayString(_ctx.bookletTableTemplate.name), 1),
                                    _createElementVNode("table", {
                                      style: _normalizeStyle(_ctx.tableGeneralStyle())
                                    }, [
                                      _createElementVNode("thead", {
                                        style: _normalizeStyle(_ctx.tableHeaderStyle(null))
                                      }, [
                                        _createElementVNode("tr", {
                                          style: _normalizeStyle(_ctx.tableHeaderStyle(null))
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerBookletTable, (header, hi) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              key: 'header_' + hi,
                                              style: _normalizeStyle(_ctx.tableHeaderStyle(header))
                                            }, _toDisplayString(header.text), 5))
                                          }), 128))
                                        ], 4)
                                      ], 4),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookletTableTemplate.rows, (row, ri) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: 'row_' + ri
                                          }, [
                                            _createElementVNode("tr", {
                                              style: _normalizeStyle(_ctx.tableRowsStyle(null))
                                            }, [
                                              _createElementVNode("td", {
                                                style: _normalizeStyle(_ctx.tableRowsStyle(row))
                                              }, _toDisplayString(row.title), 5),
                                              _createElementVNode("td", {
                                                style: _normalizeStyle(_ctx.tableRowsStyle())
                                              }, _toDisplayString(row.netAmounts[0]), 5),
                                              _createElementVNode("td", {
                                                style: _normalizeStyle(_ctx.tableRowsStyle())
                                              }, _toDisplayString(row.netAmounts[1]), 5)
                                            ], 4),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.subrows, (subrow, si) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: 'subrow_' + ri + si,
                                                style: _normalizeStyle(_ctx.tableRowsStyle(null))
                                              }, [
                                                _createElementVNode("td", {
                                                  style: _normalizeStyle(_ctx.tableRowsStyle(subrow))
                                                }, _toDisplayString(subrow.name), 5),
                                                _createElementVNode("td", {
                                                  style: _normalizeStyle(_ctx.tableRowsStyle(null))
                                                }, _toDisplayString(subrow.netAmounts[0]), 5),
                                                _createElementVNode("td", {
                                                  style: _normalizeStyle(_ctx.tableRowsStyle(null))
                                                }, _toDisplayString(subrow.netAmounts[1]), 5)
                                              ], 4))
                                            }), 128))
                                          ], 64))
                                        }), 128))
                                      ]),
                                      _createElementVNode("tfoot", {
                                        style: _normalizeStyle(_ctx.tableFooterStyle())
                                      }, [
                                        _createElementVNode("tr", {
                                          style: _normalizeStyle(_ctx.tableFooterStyle())
                                        }, [
                                          _createElementVNode("td", {
                                            style: _normalizeStyle(_ctx.tableFooterStyle())
                                          }, null, 4),
                                          _createElementVNode("td", {
                                            style: _normalizeStyle(_ctx.tableFooterStyle())
                                          }, "Total N-1", 4),
                                          _createElementVNode("td", {
                                            style: _normalizeStyle(_ctx.tableFooterStyle())
                                          }, "Total N", 4)
                                        ], 4)
                                      ], 4)
                                    ], 4)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }),
                                _createVNode(_component_v_col, { cols: "12" }),
                                _createVNode(_component_v_col, { cols: "12" }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"min-height":"50px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_divider, { class: "d-flex justify-end align-center mt-6 mb-3" }),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                (_ctx.toDisplayLogo('bottom-left'))
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "6",
                                                      class: "d-flex justify-start align-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_img, {
                                                          class: "v-responsive",
                                                          src: _ctx.logo,
                                                          style: {"width":"100%","max-width":"80px","height":"auto"}
                                                        }, null, 8, ["src"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      cols: "6",
                                                      class: "d-flex justify-start align-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.displayInformations("bottom-left")), 1)
                                                      ]),
                                                      _: 1
                                                    })),
                                                _createVNode(_component_v_col, { cols: "6" })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "6" }),
                                                (_ctx.toDisplayLogo('bottom-right'))
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "6",
                                                      class: "d-flex justify-end align-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_img, {
                                                          class: "v-responsive",
                                                          src: _ctx.logo,
                                                          style: {"width":"100%","max-width":"80px","height":"auto"}
                                                        }, null, 8, ["src"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      cols: "6",
                                                      class: "d-flex justify-end align-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.displayInformations("bottom-right")), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["cols"]),
                (!_ctx.previewMode)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "6",
                      style: {"max-height":"calc(100vh - 170px)","overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "fill-height default_card_wm elevation-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ExportThemeMenu, {
                              themeSettings: _ctx.themeSettings,
                              activeTab: _ctx.activeTab,
                              readonly: _ctx.readonly,
                              onEmitStep: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeActiveTab($event)))
                            }, null, 8, ["themeSettings", "activeTab", "readonly"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ScopeManager, {
              modelValue: _ctx.scopeSync,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scopeSync) = $event)),
              id: _ctx.scopeId,
              "onUpdate:id": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeId) = $event)),
              name: _ctx.scopeName,
              "onUpdate:name": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scopeName) = $event)),
              readonly: _ctx.readonly,
              style: {"width":"99%"}
            }, null, 8, ["modelValue", "id", "name", "readonly"])
          ])
        ]),
        _: 1
      }))
}